import type { IconNode } from '../types';

/**
 * @name dishwasher
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcgNnYyIiAvPgogIDxwYXRoIGQ9Ik0zIDdoMTgiIC8+CiAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjIwIiB4PSIzIiB5PSIyIiByeD0iMiIgLz4KICA8cGF0aCBkPSJtOSAxMS0yIDciIC8+CiAgPGNpcmNsZSBjeD0iMTQuNSIgY3k9IjE1LjUiIHI9IjIuNSIgLz4KICA8cGF0aCBkPSJtMTMgMTEtMiA3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/dishwasher
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const dishwasher: IconNode = [
  ['path', { d: 'M17 6v2', key: '1ljklf' }],
  ['path', { d: 'M3 7h18', key: '1uiuf2' }],
  ['rect', { width: '18', height: '20', x: '3', y: '2', rx: '2', key: 'od3kk9' }],
  ['path', { d: 'm9 11-2 7', key: '1peir3' }],
  ['circle', { cx: '14.5', cy: '15.5', r: '2.5', key: 'e3a30a' }],
  ['path', { d: 'm13 11-2 7', key: 'e33mnx' }],
];

export default dishwasher;
